import { useClient, useModal } from "../../../../hooks";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import React from "react";
import { SubmitButton } from "../../../../@coherent/react-hook-form";
import { FormProvider, useForm } from "react-hook-form";
import { URLs } from "../api";
import { useHistory } from "react-router-dom";

export const ConvertButton = ({ className, application, ...props }) => {
  const { isOpen, setIsOpen, toggle, Modal } = useModal();
  const form = useForm();
  const { handleSubmit } = form;
  const client = useClient();
  const history = useHistory();

  async function onSubmit() {
    const { data } = await client.post(URLs.convert(application.id));
    setIsOpen(false);
    history.push(`/registered/${data.id}`);
  }

  return (
    <>
      {isOpen ? (
        <Modal>
          <ModalHeader toggle={toggle}>
            Convert Application to Registration
          </ModalHeader>
          <ModalBody>
            Are you sure you want to convert this Volunteer Application to a
            Registration?
          </ModalBody>
          <ModalFooter>
            <FormProvider {...form}>
              <SubmitButton onClick={handleSubmit(onSubmit)}>
                Confirm
              </SubmitButton>
            </FormProvider>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      ) : null}
      <Button
        size="sm"
        color="info"
        className={className}
        onClick={toggle}
        {...props}
      >
        Add this volunteer to your session registration list
      </Button>
    </>
  );
};
